const RESET_PASSWORD_ACTION_TYPES = {
  SET_PHONE_NUMBER: 'reset-password/SET_PHONE_NUMBER',
  SET_OTP_SECRET_TOKEN: 'reset-password/SET_OTP_SECRET_TOKEN',
  SET_SECRET_TOKEN: 'reset-password/SET_SECRET_TOKEN',
  SET_OTP_CHANNEL: 'reset-password/SET_OTP_CHANNEL',
  RESET: 'reset-password/RESET',
};

export default RESET_PASSWORD_ACTION_TYPES;
